import center from '../assets/original-center.png'
import styles from './HomeSignature.module.scss'
export default function HomeSignature() {
  return (
    <span className={styles.piece} aria-hidden="true" data-testid="home-original-piece">
      <img src={center} alt="" />
    </span>
  )
}
